'use client';

import React, { useEffect } from 'react';
import cn from 'classnames';
import { LogoAllocateHorizontal } from '@dealroadshow/uikit-logo/Allocate/Horizontal';

import ContentWrp from '@framework/ui/Templates/ContentWrp';
import ScrollBodyBackground from '@framework/ui/Templates/ScrollBodyBackground';
import CookiesBanner from '@framework/cookie-consent/CookiesBanner';
import useLoginUrlWithConsent from '@framework/cookie-consent/useLoginUrlWithConsent';
import Header from '@framework/ui/Pages/Landing/Sections/Header';
import SectionFooter from '@framework/ui/Pages/Landing/Sections/Footer';
import { TabLink as NextNavLink } from '@framework/router/Next/Link';
import Button from '@dealroadshow/uikit-button';
import BookDemoButton from '@/allocate/ui/common/BookDemoButton';
import { LogoAllocateStandart } from '@dealroadshow/uikit-logo/Allocate/Standart';
import { ALLOCATE_LANDING_HEADER_MENU, ALLOCATE_LANDING_FOOTER_CONFIG } from './constants';
import config from '@allocate/config';
import allocateUrl from '@allocate/config/allocateUrl';

import stickyFooterStyles from '@framework/ui/Organisms/StickyFooter/stickyFooter.module.scss';
import styles from './layout.module.scss';

interface IProps {
  children: React.ReactNode,
  containerCls?: string,
}

const LandingLayout = ({
  children,
  containerCls,
}: IProps) => {
  const tenant = config.code;
  const loginUrl = useLoginUrlWithConsent(() => allocateUrl.getLoginUrl());

  useEffect(() => {
    const id = window.location.hash.slice(1);

    if (id) {
      document.getElementById(id)
        ?.scrollIntoView();
    }
  }, []);

  const pageContainerCls = cn(
    styles.landingPageContainer,
    stickyFooterStyles.pageContainerWithStickyFooter,
    containerCls,
  );

  return (
    <ContentWrp>
      <Header
        logoComponent={ LogoAllocateHorizontal }
        menu={ ALLOCATE_LANDING_HEADER_MENU }
        customLoginButton={ ({
          buttonProps,
          linkProps,
        }) => (
          <NextNavLink
            { ...linkProps }
            to={ loginUrl }
          >
            <Button { ...buttonProps } />
          </NextNavLink>
        ) }
        headerButton={ ({ buttonProps }) => (
          <BookDemoButton { ...buttonProps } logoComponent={ LogoAllocateStandart } />
        ) }
        mobileMenuClassName={ styles.mobileMenu }
      />
      <div className={ pageContainerCls }>
        <ScrollBodyBackground tenant={ tenant } />
        { children }
      </div>
      <SectionFooter
        config={ ALLOCATE_LANDING_FOOTER_CONFIG }
        contentClassName={ styles.footerContent }
      />
      <CookiesBanner />
    </ContentWrp>
  );
};

export default LandingLayout;
